"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.areaCalculation = exports.angleCalculation = exports.heightCalculation = exports.distanceCalculation = void 0;
const three_1 = require("three");
const transformation_1 = require("./transformation");
const pubsub_js_1 = require("pubsub-js");
let transformator = { scale: 1, type: 6 /* TO_METER */, unit: "m" };
//Subscribe to measurement type change
(0, pubsub_js_1.subscribe)("change-measurement-type" /* CHANGE_MEASUREMENT_TYPE */, (_, data) => {
    transformator.type = data.transformatorConversionType;
    transformator.unit = data.unit;
});
/** Distance calculation */
function distanceCalculation(positions, pointIdx) {
    let idx = pointIdx;
    const start = new three_1.Vector3(positions[idx++], positions[idx++], positions[idx++]);
    const end = new three_1.Vector3(positions[idx++], positions[idx++], positions[idx++]);
    let distance = start.distanceTo(end);
    distance = (0, transformation_1.transformValue)(distance, transformator);
    return distance;
}
exports.distanceCalculation = distanceCalculation;
/** Height calculation */
function heightCalculation(positions, pointIdx) {
    const start = new three_1.Vector3(positions[0], positions[1], positions[2]);
    const end = new three_1.Vector3(positions[6], positions[7], positions[8]);
    const min = start.y;
    const max = end.y;
    let height = max - min;
    // height = Math.abs(height); // Uncomment if only positive numbers are needed
    height = (0, transformation_1.transformValue)(height, transformator);
    return height;
}
exports.heightCalculation = heightCalculation;
/** Angle calculation */
function angleCalculation(positions) {
    let idx = 0;
    const start = new three_1.Vector3(positions[idx++], positions[idx++], positions[idx++]);
    const corner = new three_1.Vector3(positions[idx++], positions[idx++], positions[idx++]);
    const end = new three_1.Vector3(positions[idx++], positions[idx++], positions[idx++]);
    const v1 = new three_1.Vector3().subVectors(start, corner);
    const v2 = new three_1.Vector3().subVectors(end, corner);
    // Avoid the error printed by threejs if denominator is 0
    const denominator = Math.sqrt(v1.lengthSq() * v2.lengthSq());
    if (denominator === 0)
        return 0;
    let angle = v1.angleTo(v2);
    angle = three_1.MathUtils.radToDeg(angle);
    return angle;
}
exports.angleCalculation = angleCalculation;
/** Area calculation */
function areaCalculation(positions, pointIdx) {
    // Convert points array to vectors array
    const vectors = [];
    for (let index = 0; index < pointIdx;) {
        const vector = new three_1.Vector3(positions[index++], positions[index++], positions[index++]);
        vectors.push(vector);
    }
    let areax = 0;
    let areay = 0;
    let areaz = 0;
    let v1 = new three_1.Vector3();
    let v2 = new three_1.Vector3();
    let n = vectors.length - 1;
    for (let index = 0; index < vectors.length; index++) {
        v1.copy(vectors[index]);
        v2.copy(vectors[n]);
        areaz += (v2.x + v1.x) * (v1.y - v2.y);
        areax += (v2.z + v1.z) * (v1.y - v2.y);
        areay += (v2.x + v1.x) * (v1.z - v2.z);
        n = index;
    }
    areax = Math.abs(areax / 2);
    areax = (0, transformation_1.transformValue)(areax, transformator);
    areay = Math.abs(areay / 2);
    areay = (0, transformation_1.transformValue)(areay, transformator);
    areaz = Math.abs(areaz / 2);
    areaz = (0, transformation_1.transformValue)(areaz, transformator);
    return areax + areay + areaz;
}
exports.areaCalculation = areaCalculation;
